import React, { Component } from 'react';


//redux
import { Provider } from "react-redux";
import store from './store'

//路由
import Routers from "./router";



class App extends Component {

  render() {

    return (
      <Provider store={store}>
        <Routers />
      </Provider>
    );
  }
}



export default App;